/* 
  @FileDescription: 头部公用组件,
  @
  @params:{
    projectCode(必传参数): 产品code String,
    authCallBack: : 当前项目是否授权 验证后的回调 [Function] 返回值 type: 1(没有授权任何产品) 2(没有授权当前产品,但是有有效的授权产品) 3(没有授权当前产品,且没有有效的授权产品),
    logoDom: 自定义logo样式,
    logoUrl: 自定义logo地址,
    userMenus: 用户的项目列表 [Array],
    userInfo: 用户的基本信息 [Object],
    personalMenus: 用户的个人设置菜单 [Object],
    logoutBack: 退出函数的回调 [Function],
    NoticesTitle: 通知抽屉的标题,默认为 通知提醒 [String],
    noticesIntervalMinute: 通知轮训间隔时间,单位为分钟,默认为5 [Number],
    showNotice: 是否显示通知图标,默认为true [Boolean],
    getEnterpriseFunc: 获取企业列表的函数(axios包装好的函数) [Function],
    switchEnterpriseFunc: 切换企业的函数(axios包装好的函数) [Function],
    switchEnterpriseCallBack: 切换企业成功后的回调 [Function],
    licenseName: 当前产品的订阅方案名称 [String],
    getAuthTimeFunc: 获取授权时长的函数(axios包装好的函数) [Function],
    getAdminsFunc: 获取当前项目的管理员的函数(axios包装好的函数) [Function],
    contactBusinessCallBack: 联系商务的回调 [Function],
    editCompName: 获取企业名称的函数(axios包装好的函数) [Function],
    getLicenseFunc: 获取当前企业订阅方案信息(包含订阅方案截止时间、订阅方案名称)的函数(axios包装好的函数) [Function],
    showUserMenusMinLength: 左上角产品栏显示最小值

    ⬇️ ========>  若showNotice为true,则以下参数必传
    getUnreadNoticesFunc: 获取未读通知的函数(axios包装好的函数) [Function],
    getNoticesFunc: 获取所有通知的函数(axios包装好的函数) [Function],
    setReadNoticesFunc: 修改通知未读变已读的函数(axios包装好的函数) [Function],
    deleteNoticesFunc: 清除所有通知的函数(axios包装好的函数) [Function],
    ⬆️
    getUpdateLogList:  获取更新日志的函数(axios包装好的函数) [Function],
    validationFunc: 验证函数,验证以上函数返回值哪种状态为正确状态,默认为 (res) => res.code === 200 [Function],
  },
*/

import './index.scss'
import {
  Layout,
  Avatar,
  message,
  Badge,
  Popover,
  Drawer,
  Button,
  Tooltip,
  Typography,
  Form,
  Input,
  Modal,
  Space,
} from 'antd'
import logo from './logo.png'
import { ReactSVG } from 'react-svg'
import NoticeDrawer from './components/NoticeDrawer'
import { useEffect, useRef, useState } from 'react'
import { useGetState, useUnmount } from 'ahooks'
import UpdateLogsDrawer from './components/UpdateLogsDrawer'
import {
  UnorderedListOutlined,
  SwapOutlined,
  CloseOutlined,
  GoldFilled,
  CheckOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons'
import moment from 'moment'
import { setCallbackUrl } from '../../utils/cookie'
import MyButton from '../MyButton'
import { useHistory } from 'react-router-dom'
const { Paragraph } = Typography

const { Header } = Layout
const UserInfoCard = (props) => {
  const {
    userInfo = {},
    personalMenus = {},
    logoutBack,
    setUpdateLogsVisible,
    enterpriseList = [],
    validationFunc,
    switchEnterpriseFunc,
    switchEnterpriseCallBack,
    licenseName,
    getEnterprise,
    userMenus,
    projectCode = null,
    menuClickCallBack,
    editCompName,
    getLicenseFunc = null,
  } = props

  const [visible, setVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [switchCompVisible, setSwitchCompVisible] = useState(false)
  const [infoVisible, setInfoVisible] = useState(false)

  const [value, setValue] = useState('')
  const [coId, setCoId, getCoId] = useGetState(null)
  const [currentId, setCurrentId, getCurrentId] = useGetState(null)
  const [licenseList, setLicenseList, getLicenseList] = useGetState(null)
  const [form] = Form.useForm()

  useEffect(() => {
    getLicenseFunc &&
      getLicenseFunc(projectCode).then((res) => {
        console.log('-----getLicenseFunc', res)
        if (validationFunc(res)) {
          setLicenseList(res.data)
        }
      })
  }, [])
  const openNewWin = (item) => {
    if (item?.menu_name === '退出登录') {
      logoutBack && logoutBack()
      return
    }
    if (item?.menu_name === '更新日志') {
      setUpdateLogsVisible(true)
      return
    }
    if (item?.menu_name === '联系客服') {
      let href = item.menu_url
      const menuItem = userMenus?.find((_) => _.menu_code === projectCode) || {}
      let params = {
        project_name: menuItem?.menu_name || '导航页',
        co_name: userInfo?.co_name,
        co_id: userInfo?.co_id,
        user_name: userInfo?.show_name,
        user_id: userInfo?.co_user_id,
      }
      href =
        href + '?info=' + window?.encodeURIComponent(JSON.stringify(params))
      window.open(href, item?.menu_name)
      return
    }
    if (!item.menu_url) {
      message.info('没有设置跳转链接!')
      return
    }
    setCallbackUrl(window.location.href)
    menuClickCallBack && menuClickCallBack(item)
    if (menuClickCallBack && menuClickCallBack(item)) {
      return
    }
    window.open(item.menu_url, item?.menu_name)
  }

  //切换企业
  const switchEnterprise = () => {
    if (getCurrentId() === userInfo?.co_id) {
      setVisible(false)
      return
    }
    switchEnterpriseFunc &&
      switchEnterpriseFunc(getCurrentId()).then((res) => {
        console.log(res)
        if (validationFunc(res)) {
          switchEnterpriseCallBack && switchEnterpriseCallBack(res.data)
          setVisible(false)
          setSwitchCompVisible(false)
        } else {
          message.error(res?.data?.message || '切换失败')
        }
      })
  }

  //更改企业名称
  const updateCompName = () => {
    form.validateFields().then((values) => {
      editCompName({
        ...values,
        co_id: getCurrentId(),
      }).then((res) => {
        if (validationFunc(res)) {
          message.success('修改成功')
          getEnterprise()
          setEditVisible(false)
        } else {
          message.error(res?.data?.msg)
        }
      })
    })
  }
  return (
    <div className="userInfoCardContent">
      <div className="userLogoContent">
        <Avatar size={52} src={userInfo?.pf_photo} />
        <div className="userNameBox">
          {/* {userInfo?.show_name} */}
          <Paragraph
            ellipsis={{
              rows: 1,
              tooltip: userInfo?.show_name,
            }}
            style={{
              maxWidth: '180px',
              marginBottom: '0px',
            }}
          >
            {userInfo?.show_name}
          </Paragraph>
          {userInfo?.co_id && userInfo?.co_type_code !== 'INDIV_ORG' ? (
            userInfo?.is_admin || userInfo?.is_creator ? (
              <div className="userRoleTag">
                {userInfo?.is_creator ? '创建者' : '管理员'}
              </div>
            ) : (
              <div className="userRoleTag">成员</div>
            )
          ) : null}
        </div>
        {licenseName && !getLicenseList() && (
          <Tooltip
            visible={licenseName?.length > 10 ? undefined : false}
            title={<span style={{ fontSize: '12px' }}>{licenseName}</span>}
          >
            <div className="userTagBox">
              {licenseName?.slice(0, 10) +
                (licenseName?.length > 10 ? '...' : '')}
            </div>
          </Tooltip>
        )}
        {userInfo?.pf_photo && (
          <div className="userLogoBg">
            <img src={userInfo?.pf_photo} alt="" />
          </div>
        )}
        {userInfo?.co_name && (
          <div className="userCoNameBox">
            <Paragraph
              ellipsis={{
                rows: 1,
                tooltip:
                  userInfo?.co_type_code !== 'INDIV_ORG'
                    ? userInfo?.co_name
                    : '用户ID: ' + userInfo?.individual_id,
              }}
              style={{
                maxWidth: '200px',
                marginBottom: '0px',
                color: '#9E9E9E',
              }}
            >
              {userInfo?.co_type_code !== 'INDIV_ORG'
                ? userInfo?.co_name
                : '用户ID: ' + userInfo?.individual_id}
            </Paragraph>

            {(enterpriseList || [])?.filter(
              (_) => _.co_type_code !== 'INDIV_ORG'
            )?.length > 0 && userInfo?.co_type_code !== 'INDIV_ORG' ? (
              <span
                className="anticon"
                onClick={() => {
                  setCoId(userInfo.co_id)
                  getEnterprise && getEnterprise()
                  setTimeout(() => {
                    setVisible(true)
                  }, 100)
                }}
              >
                <svg
                  t="1713852843484"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9852"
                  width="16"
                  height="16"
                >
                  <path
                    d="M576 917.333333h42.666667V349.696l210.346666 113.92 2.624 1.216a113.941333 113.941333 0 0 1 64.256 97.152l0.106667 4.992v236.330667l-0.085333 4.586666c-2.389333 59.306667-50.752 106.944-110.933334 109.354667L780.16 917.333333 576 917.312V917.333333H245.333333c-63.210667 0-114.773333-48.853333-117.248-110.037333L128 802.688V313.962667c0-43.626667 25.322667-83.306667 65.024-102.613334l4.650667-2.133333 213.333333-92.650667c59.221333-25.706667 128.554667 0.362667 154.88 58.218667 5.824 12.8 9.194667 26.56 9.941333 40.533333l0.170667 6.016V917.333333z m-160-298.666666h-128a32 32 0 0 0-3.072 63.850666L288 682.666667h128a32 32 0 0 0 0-64z m362.666667 0H682.666667v64h96a32 32 0 0 0 0-64z m-362.666667-170.666667h-128a32 32 0 0 0-3.072 63.850667L288 512h128a32 32 0 0 0 0-64z"
                    fill="#0068b2"
                    p-id="9853"
                  ></path>
                </svg>
                <svg
                  t="1713856253107"
                  className="icon_xia"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="18103"
                  width="6"
                  height="6"
                >
                  <path
                    d="M589.320643 836.512614c137.245586-179.809148 274.469497-359.614683 411.693408-539.422024 48.874492-64.014224 3.225908-156.297589-77.322449-156.297589H100.306592c-80.548357 0-126.195135 92.283365-77.342318 156.297589 137.24378 179.807341 274.467691 359.612876 411.713277 539.422024 38.933061 51.009444 115.711837 51.009444 154.643092 0z"
                    fill="#0068b2"
                    p-id="18104"
                  ></path>
                </svg>
              </span>
            ) : null}
          </div>
        )}
      </div>
      {getLicenseList() && (
        <div className="licenseListBox">
          {getLicenseList().map((_) => {
            const len = getLicenseList().length
            const w = len === 1 ? '100%' : `calc(${100 / len}% - 4px)`
            return (
              <div
                className="licenseItemBox"
                style={{ width: w }}
                key={_.name + _.type}
              >
                <svg
                  fill="none"
                  version="1.1"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  className="topIcon"
                >
                  <defs>
                    <linearGradient
                      x1="0"
                      y1="1"
                      x2="1.0152994394302368"
                      y2="0.3041720986366272"
                      id="master_svg0_547_04143"
                    >
                      <stop offset="0%" stop-color="#FF91A6" stop-opacity="1" />
                      <stop
                        offset="100%"
                        stop-color="#FFC683"
                        stop-opacity="1"
                      />
                    </linearGradient>
                  </defs>
                  <g>
                    <g>
                      <path
                        d="M0 0C0 0 0 0 0 0L13 0C15.209138999323173 0 17 1.7908610006768266 17 4L17 16C17 16 17 16 17 16L4 16C1.7908610006768266 16 0 14.209138999323173 0 12Z"
                        fill="currentColor"
                        fill-opacity="1"
                      />
                    </g>
                    <g>
                      <g>
                        <path
                          d="M7.379160000000001,4.00011728L7.34148,4.00011728C7.02375,4.00011728,6.81088,4.00011728,6.606809999999999,4.0493473C6.51447,4.0712965,6.4241600000000005,4.100731,6.3368,4.137346C6.1434,4.218576,5.9776299999999996,4.343497,5.73525,4.526879L5.7057400000000005,4.549032L5.69192,4.558878C5.25426,4.889335,4.907019,5.15149,4.652082,5.38594C4.391493,5.62594,4.199349,5.86101,4.098253,6.1490100000000005C4.0155493,6.38408,3.9845204,6.633649999999999,4.00720399,6.88131C4.0348326,7.182840000000001,4.165441,7.4536,4.361981,7.74037C4.553498,8.02098,4.827901,8.3459,5.17263,8.75451L6.87179,10.76494C7.17948,11.12986,7.43316,11.429549999999999,7.666119999999999,11.63508C7.91038,11.85046,8.17222,12,8.5,12C8.82778,12,9.08962,11.85108,9.33388,11.63508C9.566220000000001,11.429549999999999,9.8199,11.12986,10.12821,10.76494L11.826740000000001,8.75451C12.1721,8.3459,12.4465,8.02098,12.63802,7.74037C12.83456,7.453609999999999,12.96454,7.183450000000001,12.9928,6.8806899999999995C13.01548,6.63303,12.98445,6.38347,12.90175,6.14839C12.80128,5.86101,12.60851,5.62532,12.34792,5.38594C12.09298,5.15149,11.74511,4.889335,11.30808,4.558879L11.294260000000001,4.549033L11.26475,4.526879C11.021740000000001,4.343497,10.8566,4.218576,10.6632,4.137346C10.575859999999999,4.100526,10.48554,4.0708863,10.39319,4.0487322C10.189119999999999,3.999502148,9.97625,3.999502148,9.65852,4.000117561L7.379160000000001,4.00011728ZM7.66298,6.2567L9.337019999999999,6.2567C9.51042,6.2567,9.65099,6.3944600000000005,9.65099,6.5643899999999995C9.65099,6.73432,9.51042,6.87207,9.337019999999999,6.87208L7.66298,6.87208C7.48958,6.87207,7.349019999999999,6.73432,7.349019999999999,6.5643899999999995C7.349019999999999,6.3944600000000005,7.48958,6.2567,7.66298,6.2567Z"
                          fill="#FFFFFF"
                          fill-opacity="1"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
                <div className="licenseType">{_.product_name}</div>
                <div className="licenseVersion">{_.subs_plan_name}</div>
                <div className="licenseLine"></div>
                <div className="licenseDate">
                  授权至{moment(_.license_deadline_time).format('YYYY/MM/DD')}
                </div>
              </div>
            )
          })}
        </div>
      )}
      <div className="personalMenusContent">
        {Object.keys(personalMenus || {}).map((key, index) => (
          <div className="personalMenusBox" key={key}>
            {index ? <div className="personalMenusLine"></div> : null}
            {(personalMenus[key] || [])?.map((item) => (
              <div
                className="personalMenusItem"
                onClick={() => {
                  openNewWin(item)
                }}
                key={item?.menu_name}
              >
                <ReactSVG
                  className="personalMenusItemIcon"
                  src={item?.icon}
                ></ReactSVG>
                {item.menu_name}
              </div>
            ))}
          </div>
        ))}
      </div>

      <Drawer
        maskClosable={false}
        destroyOnClose={true}
        className="enterpriseDrawer"
        width="600px"
        closable={false}
        title="企业或组织"
        zIndex={1031}
        placement="right"
        push={false}
        extra={
          <CloseOutlined
            style={{ fontSize: '16px' }}
            onClick={() => {
              setVisible(false)
            }}
          />
        }
        onClose={() => {
          setVisible(false)
        }}
        visible={visible}
        footer={null}
      >
        <div className="enterpriseDrawerContent">
          {(enterpriseList || [])
            ?.filter((_) => _.co_type_code !== 'INDIV_ORG')
            ?.map((item) => {
              return (
                <div
                  key={item?.co_id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: '30px',
                  }}
                  className={
                    item?.co_id === coId
                      ? 'enterpriseItem activeEnterpriseItem'
                      : 'enterpriseItem'
                  }
                >
                  <div
                    onClick={() => {
                      if (item.user_status_code === 'DISABLE') {
                        setInfoVisible(true)
                      } else {
                        if (coId !== item.co_id) {
                          setSwitchCompVisible(true)
                          setCurrentId(item.co_id)
                        }
                      }
                    }}
                  >
                    <GoldFilled />
                    <span className="labelSpan">
                      {item?.co_name}
                      {item.user_status_code === 'DISABLE' && (
                        <Badge
                          offset={[25, -8]}
                          count={'禁用'}
                          style={{
                            backgroundColor: '#52c41a',
                            fontSize: '12px',
                          }}
                        >
                          <div></div>
                        </Badge>
                      )}
                      <CheckOutlined />
                    </span>
                  </div>
                  {item.is_creator && (
                    <div>
                      <a
                        style={{ color: '#0068b2' }}
                        onClick={() => {
                          setCurrentId(item.co_id)
                          setEditVisible(true)
                        }}
                      >
                        更改名称
                      </a>
                    </div>
                  )}
                </div>
              )
            })}
        </div>
      </Drawer>
      <Drawer
        closable={false}
        push={false}
        extra={
          <CloseOutlined
            style={{ fontSize: '16px' }}
            onClick={() => {
              setEditVisible(false)
            }}
          />
        }
        maskClosable={false}
        destroyOnClose={true}
        className="enterpriseDrawer"
        width="600px"
        zIndex={1032}
        visible={editVisible}
        onClose={() => {
          setEditVisible(false)
        }}
        title="更改企业或组织名称"
        footer={
          <div className="drawerFooterBtnBox">
            <Button
              onClick={() => {
                updateCompName()
              }}
              type="primary"
            >
              更改
            </Button>
            <Button
              onClick={() => {
                setEditVisible(false)
              }}
            >
              取消
            </Button>
          </div>
        }
      >
        <Form
          validateTrigger={['onBlur', 'onChange']}
          form={form}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            style={{ padding: '10px 20px 0px 20px' }}
            name="co_name"
            label="企业或组织名称"
            rules={[
              {
                required: true,
                message: '企业或组织名称不能为空',
              },
            ]}
          >
            <Input style={{ marginTop: 6 }}></Input>
          </Form.Item>
        </Form>
      </Drawer>
      <Modal
        title="切换企业"
        maskClosable={false}
        centered
        visible={switchCompVisible}
        zIndex={1033}
        onCancel={() => setSwitchCompVisible(false)}
        className="switchCompModel"
        footer={[
          <Space size={[24]} className="model-btn">
            <Button onClick={() => setSwitchCompVisible(false)}>取消</Button>
            <Button
              type="primary"
              onClick={() => {
                switchEnterprise()
              }}
            >
              切换
            </Button>
          </Space>,
        ]}
      >
        <div style={{ textAlign: 'center' }}>
          <span>确定要切换企业吗？</span>
        </div>
      </Modal>
      <Modal
        title=""
        maskClosable={false}
        centered
        visible={infoVisible}
        zIndex={1033}
        closable={false}
        onCancel={() => setInfoVisible(false)}
        className="switchCompModel"
        footer={[
          <Space size={[24]} className="model-btn">
            <Button onClick={() => setInfoVisible(false)}>知道了</Button>
          </Space>,
        ]}
      >
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '20px' }}>该企业已禁用您的账号！</p>
          <p style={{ color: '#999999' }}>如有疑问请联系企业管理员</p>
        </div>
      </Modal>
    </div>
  )
}
const MoreProjectPopoverContent = (props) => {
  const { userMenus } = props

  return (
    <div className="moreProjectPopoverContent">
      {userMenus?.map((item) => (
        <div
          className="projectItemBox"
          key={item.menu_name}
          onClick={() => {
            window.open(item.menu_url, item?.menu_name)
          }}
        >
          <img src={item.icon} alt={item.menu_name} />
          <span>{item.menu_name}</span>
        </div>
      ))}
    </div>
  )
}

export function MyHeader(props) {
  const {
    projectCode = null,
    authCallBack,
    logoDom = null,
    logoUrl = null,
    userInfo = {},
    userMenus = null,
    personalMenus = {},
    logoutBack,
    licenseName,
    showNotice = true,
    getUnreadNoticesFunc,
    getNoticesFunc,
    setReadNoticesFunc,
    deleteNoticesFunc,
    getUpdateLogList,
    getEnterpriseFunc,
    switchEnterpriseFunc,
    switchEnterpriseCallBack,
    validationFunc = (res) => res.code === 200,
    NoticesTitle = '通知提醒',
    noticesIntervalMinute = 5,
    getAuthTimeFunc = null,
    getAdminsFunc = null,
    contactBusinessCallBack = null,
    menuClickCallBack,
    editCompName,
    getLicenseFunc = null,
    showUserMenusMinLength = 1,
  } = props
  const history = useHistory()
  const [noticeVisible, setNoticeVisible] = useState(false)
  const [updateLogsVisible, setUpdateLogsVisible] = useState(false)
  const [passWordModal, setPassWordModal] = useState(false)
  const [enterpriseList, setEnterpriseList] = useState([])
  const [unreadNoticesTotal, setUnreadNoticesTotal] = useState(0)
  const [showUserMenus, setShowUserMenus] = useState([])
  const [authTimeArr, setAuthTimeArr] = useState([])
  const [admins, setAdmins] = useState([])

  // console.log(enterpriseList);
  const timer = useRef(null)

  useUnmount(() => {
    clearInterval(timer.current)
  })

  useEffect(() => {
    if (!userMenus) {
      return
    }
    //授权项目列表为空
    if (userMenus?.length === 0) {
      authCallBack && authCallBack(1)
    } else {
      //授权项目列表不为空 并且没有授权此项目
      if (!userMenus?.some((item) => item.menu_code === projectCode)) {
        //跳转第一个授权的项目
        const findItem = userMenus?.find((i) => i.menu_url)
        if (findItem) {
          authCallBack && authCallBack(2)
        } else {
          authCallBack && authCallBack(3)
        }
      }
    }
    const _userMenus = (userMenus || [])?.filter((_) => _.menu_url)
    setShowUserMenus(JSON.parse(JSON.stringify(_userMenus || [])))
  }, [userMenus])

  const getNotices = () => {
    getUnreadNoticesFunc &&
      getUnreadNoticesFunc().then((res) => {
        console.log('获取未读通知', new Date(), res)
        if (validationFunc(res)) {
          setUnreadNoticesTotal(res.data?.total)
        }
      })
  }

  //获取企业列表
  const getEnterprise = () => {
    if (getEnterpriseFunc) {
      getEnterpriseFunc().then((res) => {
        console.log('-----', res)
        if (validationFunc(res)) {
          setEnterpriseList(res.data)
        } else {
          setEnterpriseList([])
        }
      })
    }
  }

  //切换企业类型
  const switchCoType = (isEnterprise) => {
    if (getEnterpriseFunc) {
      getEnterpriseFunc().then((res) => {
        console.log('-----', res)
        if (validationFunc(res)) {
          // setEnterpriseList(res.data);
          let co_list = res.data || []
          co_list = co_list.filter((item) => item.user_status_code === 'ENABLE')
          let item = co_list?.find((_) => {
            if (isEnterprise) {
              return (
                _.co_type_code === 'FORMAL_CORP' ||
                _.co_type_code === 'ADMIN_GROUP'
              )
            } else {
              return _.co_type_code === 'INDIV_ORG'
            }
          })
          if (item) {
            switchEnterpriseFunc &&
              switchEnterpriseFunc(item.co_id).then((res) => {
                console.log(res)
                if (validationFunc(res)) {
                  switchEnterpriseCallBack && switchEnterpriseCallBack(res.data)
                  // setVisible(false);
                } else {
                  message.error(res?.data?.message || '切换失败')
                }
              })
          }
        } else {
          // setEnterpriseList([]);
          message.error(res.data)
        }
      })
    }
  }

  const authTimeFunc = () => {
    if (!(userInfo?.is_admin || userInfo?.is_creator)) {
      getAdminsFunc &&
        getAdminsFunc().then((res) => {
          if (validationFunc(res)) {
            setAdmins(res.data)
          } else {
            setAdmins([])
          }
        })
    }
    getAuthTimeFunc().then((res) => {
      if (validationFunc(res)) {
        setAuthTimeArr(res.data)
      } else {
        setAuthTimeArr([])
      }
    })
  }

  useEffect(() => {
    if (!userInfo) {
      return
    }
    if (userInfo.remind_to_set_password) {
      setPassWordModal(true)
    }
  }, [userInfo])

  useEffect(() => {
    if (getAuthTimeFunc) {
      authTimeFunc()
    }
    if (showNotice) {
      getNotices()
      timer.current = setInterval(() => {
        getNotices()
      }, noticesIntervalMinute * 60 * 1000)
    }
    getEnterprise()
  }, [])

  const initAuthDom = () => {
    if (JSON.stringify(authTimeArr) === '[]') {
      return
    }
    let color = ''
    let text = ''
    if (authTimeArr?.at(0) === false) {
      color = '#FE545F'
      text = '您的订阅已经过期，'
    } else if (
      moment(new Date())
        .add(authTimeArr?.at(2) || 0, 'days')
        .isAfter(authTimeArr?.at(1))
    ) {
      color = '#61D4AD'
      text = `您的订阅即将过期（截止时间：${authTimeArr?.at(1)}），`
    }
    return (
      <div className="authTimeBox" style={{ color }}>
        {text}
        {text &&
          (userInfo?.is_admin || userInfo?.is_creator ? (
            <>
              请
              <a
                onClick={() => {
                  contactBusinessCallBack && contactBusinessCallBack()
                }}
              >
                联系商务
              </a>
              续订！
            </>
          ) : (
            <>
              请联系
              <Popover
                placement="bottomLeft"
                title={null}
                // visible={true}
                overlayClassName="headerAdminPopover"
                content={
                  <div className="adminPopoverContent">
                    {(admins || [])?.map((item) => (
                      <div className="adminPopoverItem">
                        <span>
                          <Avatar
                            style={{ marginRight: '8px' }}
                            size={24}
                            src={item?.pf_photo}
                          />
                          {item?.show_name}
                        </span>
                        <span>{item?.assist_name}</span>
                      </div>
                    ))}
                  </div>
                }
              >
                <a className="adminBox">管理员</a>
              </Popover>
              续订！
            </>
          ))}
      </div>
    )
  }

  return (
    <div className="headerContainer">
      <Header>
        <div className="left-title-box">
          {showUserMenus?.length > showUserMenusMinLength ? (
            <Popover
              placement="bottomLeft"
              title={null}
              // open={true}
              overlayClassName="moreProjectPopover"
              content={
                <MoreProjectPopoverContent
                  userMenus={showUserMenus}
                ></MoreProjectPopoverContent>
              }
            >
              <div className="moreProjectBox">
                <UnorderedListOutlined />
              </div>
            </Popover>
          ) : null}
          <span className="left-title">
            {logoDom ? (
              logoDom
            ) : (
              <img src={logoUrl || logo} alt="" className="logoImg" />
            )}
          </span>
          {(userInfo?.co_type_code === 'FORMAL_CORP' ||
            userInfo?.co_type_code === 'INDIV_ORG') && (
            <div className="typeBox">
              {userInfo?.co_type_code === 'INDIV_ORG' ? '个人版' : '企业版'}
            </div>
          )}
          {initAuthDom()}
        </div>
        <div className="ant-header-right">
          {userInfo?.co_type_code !== 'INDIV_ORG' &&
            enterpriseList?.some((_) => _.co_type_code === 'INDIV_ORG') && (
              <div className="typeBtnBox">
                <div
                  className="typeBtn"
                  onClick={() => {
                    switchCoType(false)
                  }}
                >
                  <CheckCircleOutlined />
                  切换个人版
                </div>
              </div>
            )}
          {userInfo?.co_type_code !== 'FORMAL_CORP' &&
            userInfo?.co_type_code !== 'ADMIN_GROUP' &&
            enterpriseList
              ?.filter((item) => item.user_status_code === 'ENABLE')
              ?.some(
                (_) =>
                  _.co_type_code === 'FORMAL_CORP' ||
                  _.co_type_code === 'ADMIN_GROUP'
              ) && (
              <div className="typeBtnBox" style={{ marginLeft: '10px' }}>
                <div
                  className="typeBtn"
                  onClick={() => {
                    switchCoType(true)
                  }}
                >
                  <CheckCircleOutlined />
                  切换企业版
                </div>
              </div>
            )}
          {/* {(userInfo?.co_type_code === "FORMAL_CORP" ||
            userInfo?.co_type_code === "INDIV_ORG") && (
            <div className="typeBtnBox">
              <div className="typeBtn" onClick={switchCoType}>
                <CheckCircleOutlined />
                切换
                {userInfo?.co_type_code === "INDIV_ORG" ? "企业版" : "个人版"}
              </div>
            </div>
          )} */}
          <div className="menuItem">
            {showNotice && (
              <div onClick={() => setNoticeVisible(true)}>
                <Badge dot={unreadNoticesTotal > 0}>
                  <svg
                    t="1700034494573"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    p-id="4887"
                    width="18"
                    height="18"
                    className="cursor-pointer"
                  >
                    <path
                      d="M512 64c16.569 0 30 13.431 30 30l0.003 36.008C681.395 137.891 792 253.424 792 394.79v201.955a30 30 0 0 0 14.1 25.44l48.92 30.575C895.443 678.025 920 722.331 920 770c0 49.706-40.294 90-90 90H638.521C624.978 917.335 573.471 960 512 960c-61.471 0-112.978-42.666-126.521-100H194c-49.706 0-90-40.294-90-90 0-47.669 24.557-91.975 64.98-117.24l48.92-30.575a30 30 0 0 0 14.1-25.44V394.79c0-141.366 110.605-256.9 249.998-264.782L482 94c0-16.569 13.431-30 30-30z m63.264 796H448.736c11.235 23.65 35.34 40 63.264 40s52.03-16.35 63.264-40zM526.79 189.58h-29.58C383.876 189.58 292 281.454 292 394.79v201.955a90 90 0 0 1-42.3 76.32l-48.92 30.575A78.255 78.255 0 0 0 164 770c0 16.569 13.431 30 30 30h636c16.569 0 30-13.431 30-30 0-26.981-13.9-52.06-36.78-66.36l-48.92-30.575a90 90 0 0 1-42.3-76.32V394.79c0-113.335-91.876-205.21-205.21-205.21z"
                      fill="#000000"
                      p-id="4888"
                    ></path>
                  </svg>
                </Badge>
              </div>
            )}
          </div>

          {/* <div className="menuItem"></div> */}

          <div className="menuItem">
            <Popover
              placement="bottomRight"
              title={null}
              overlayClassName="userInfoCardPopover"
              content={
                <UserInfoCard
                  userInfo={userInfo}
                  personalMenus={personalMenus}
                  logoutBack={logoutBack}
                  setUpdateLogsVisible={setUpdateLogsVisible}
                  switchEnterpriseFunc={switchEnterpriseFunc}
                  enterpriseList={enterpriseList}
                  switchEnterpriseCallBack={switchEnterpriseCallBack}
                  validationFunc={validationFunc}
                  licenseName={licenseName}
                  getEnterprise={getEnterprise}
                  projectCode={projectCode}
                  userMenus={userMenus}
                  menuClickCallBack={menuClickCallBack}
                  editCompName={editCompName}
                  getLicenseFunc={getLicenseFunc}
                ></UserInfoCard>
              }
            >
              {/* {userInfo?.show_name} */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Paragraph
                  ellipsis={{
                    rows: 1,
                    tooltip: userInfo?.show_name,
                  }}
                  style={{
                    maxWidth: '160px',
                    marginBottom: '0px',
                    display: 'inline-block',
                  }}
                >
                  {userInfo?.show_name}
                </Paragraph>
                <Avatar
                  style={{ marginLeft: '8px' }}
                  size={28}
                  src={userInfo?.pf_photo}
                />
              </div>
            </Popover>
          </div>
        </div>
      </Header>

      <NoticeDrawer
        visible={noticeVisible}
        onClose={() => setNoticeVisible(false)}
        getUnreadNoticesFunc={getUnreadNoticesFunc}
        getNoticesFunc={getNoticesFunc}
        setReadNoticesFunc={setReadNoticesFunc}
        deleteNoticesFunc={deleteNoticesFunc}
        setUnreadNoticesTotal={setUnreadNoticesTotal}
        validationFunc={validationFunc}
        NoticesTitle={NoticesTitle}
      ></NoticeDrawer>

      <UpdateLogsDrawer
        visible={updateLogsVisible}
        onClose={() => setUpdateLogsVisible(false)}
        validationFunc={validationFunc}
        getUpdateLogList={getUpdateLogList}
      ></UpdateLogsDrawer>
      {/* 设置密码提示 */}
      <Modal
        bodyStyle={{ textAlign: 'center' }}
        centered
        closable={false}
        onCancel={() => setPassWordModal(false)}
        title="提示"
        visible={passWordModal}
        getContainer={false}
        footer={[
          <Space size={[24]} className="model-btn">
            <MyButton onClick={() => setPassWordModal(false)}>
              暂不设置
            </MyButton>
            <MyButton
              type="default"
              onClick={() => {
                history.push('/saas/personalsettings')
                setPassWordModal(false)
              }}
            >
              立即设置
            </MyButton>
          </Space>,
        ]}
      >
        <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
          是否设置登录密码？
        </p>
        <p>登录密码设置后，可以通过手机号/密码方式登录</p>
        <p>您也可以稍后在“个人设置”中设置登录密码</p>
      </Modal>
    </div>
  )
}

export default MyHeader
